import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import * as base64 from "base-64";
import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import remark from "../../../../../Assets/icons/plus-circle.svg";
import download from "../../../../../Assets/icons/download.svg";
import { Modal } from "react-bootstrap";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";

const ServicesGetPassList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecored, setTotalRecored] = useState(0);
  const token = localStorage.getItem("authToken");
  const [jobGetPass, setJobGetPass] = useState([]);
  const [remarkModel, setRemarkModel] = useState(false);
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [Remark, setRemark] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [totalGetList, setTotalGetList] = useState(null);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});
  const [tableLoder,setTableLodre] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchJobCardInvoiceList();
  }, [fromDate, toDate]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardInvoiceList(newPage);
  };
  const DownLoadPdf = (row) => {
    var text = row?.job_card_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}jobcardpdfreport/jobCardGatePassDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };


  const handleEdit = (rowData) => {
    navigate("services-get-pass-details", { state: { rowData } });
  };

  const Job_Card_TABLE_HEADERS = [
    "Invoice No.",
    "Job Card No.",
    "Registration No.",
    "Customer Name",
    "Product Name",
    "Chassis No.",
    "Engine No.",
    "Variant Name",
    "Remark",
    "Actions",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Invoice No.": "invoice_no",
    "Job Card No.": "job_card_no",
    "Registration No.": "registration_no",
    "Customer Name": "customer_name",
    "Product Name": "product_name",
    "Chassis No.": "chassis_no",
    "Engine No.": "engine_no",
    "Variant Name": "variant_name",
    Remark: "Remark",
    Actions: "Action",
  };

  const fetchJobCardInvoiceList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
const payload= {
  orderBy: "job_card_id desc",
  page,
  pageSize,
  business_partner_id: 1,
  status: allfilteredData?.status ? allfilteredData?.status : "",
  fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
  toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
  searchText:searchTerm,
}
    try {
      setTableLodre(true)
      const response = await axiosInstance.post(
        "/jobcardgatepass/list",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTableLodre(false)
      const formattedData = response.data.data.data?.map((item, index) => ({
        ...item,
        Sr_No: index + 1,
        status: item?.solved === 0 ? "Pending" : "Done",
        Remark:
          item?.delivery_date === null ? (
            onclickRemark(item)
          ) : (
            <div>{item?.delivery_remark}</div>
          ),
        Action: item?.delivery_date !== null ? onClickAction(item) : "",
      }));
      setJobGetPass(formattedData);
      setTotalRecored(response?.data?.data?.totalRecords);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setTotalGetList(response?.data?.data);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const onClickRemarkModelOpen = (rowdata) => {
    setFormData((pre) => ({
      ...pre,
      business_partner_id: rowdata?.business_partner_id,
      job_card_id: rowdata?.job_card_id,
    }));
    setRemarkModel(true);
  };

  const onclickRemark = (rowdata) => {
    return (
      <div onClick={() => onClickRemarkModelOpen(rowdata)}>
        <img src={remark} alt="back" />
      </div>
    );
  };

  const onClickAction = (rowdata) => {
    return (
      <div onClick={() => DownLoadPdf(rowdata)}>
        <img src={download} alt="back" />
      </div>
    );
  };

  const servicesData = [
    {
      name: "remark",
      label: "Remark",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const handleClicableRow = (row) => {};

  const handleFormSubmit = async (data) => {
    try {
      const response = await axiosInstance.post(
        "/jobcardgatepass/generateJobCardGatePass",
        {
          business_partner_id: data?.business_partner_id,
          job_card_id: data?.job_card_id,
          delivery_remark: Remark,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRemarkModel(false);
      fetchJobCardInvoiceList();
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const onClearClick = () => {
    setFromDate("");
    setToDate("");
    fetchJobCardInvoiceList();
  };

  useEffect(() => {
    fetchJobCardInvoiceList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardInvoiceList();
  };

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      status: filterFormData.status || null,
    });
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "status",
      label: "Status",
      placeholder: "Select Status",
      type: "dropdown",
      options: [
        {
          label: "Pending",
          value: "P",
        },
        {
          label: "Deliver",
          value: "D",
        },
      ],
      required: true,
      gridClass: "col-lg-3",
    },
  ];

  const handleSearchInputChange = (event) => {
    setSearchTerm(event?.target?.value);
  };

  const heandelOnkeyDown = (event) => {
    if (event?.key === "Enter") {
      fetchJobCardInvoiceList();
    }
  };

  const clearSearchAndFetch =()=>{
    setSearchTerm('');
  }

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer col-md-4  mt-2 mb-2">
          <h5 style={{fontWeight:"600"}} >Service Gate Pass</h5>
        </div>
        <div className=" col-md-8 mt-2 mb-2 totalvaluescontainer ">
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              &#8377;{totalGetList?.total || 0}
            </div>
            <div>Total Requests</div>
          </div>
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              &#8377;{totalGetList?.total_pending || 0}
            </div>
            <div>Pending Requests</div>
          </div>
          <div
            // key={}
            className="topleftdataContainer"
          >
            <div className="listTopDataValueText">
              &#8377;{totalGetList?.total_approve || 0}
            </div>
            <div>Approved Requests</div>
          </div>
        </div>
      </div>

      <div className="filterView">
        <div style={{paddingTop:"40px"}} className="filterLeftView  col-md-4 gap-2">
          <h5 style={{fontWeight:"600"}} >Gate Pass List</h5>
          <div className="searchinput-wrapper">
            <input
              type="text"
              className="searchinput"
              placeholder="Search Name"
              value={searchTerm}
              onChange={handleSearchInputChange}
              onKeyDown={heandelOnkeyDown}
            />
            {searchTerm ? (
                <IoMdClose size={22} className="searchinput-close-icon" onClick={clearSearchAndFetch} />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )} 
          </div>
        </div>
        <div className="filterRightView col-md-8 gap-2">
          <h5 style={{paddingTop:"30px"}}>Filter By</h5>
          <ListLogisticsFilters
            formConfig={PhysicalStockTakingInputs}
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleSearch}
            handleClear={clearFilter}
            // onSubmit={handleFormSubmit}
          />
        </div>
      </div>

      <div className="tableWrapper">
        <CustomTable
          data={jobGetPass}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleViewButton={handleEdit}
          handleClicableRow={handleClicableRow}
          // onPriviledges={DownLoadPdf}
          pdfDownLoad={DownLoadPdf}
          totalRecords={totalRecored}
          tableLoaderShow={tableLoder}
        />
      </div>
      {remarkModel && (
        <Modal
          show={remarkModel}
          onHide={() => setRemarkModel(false)}
          centered
          size="m"
          className="large"
        >
          <Modal.Header closeButton>
            <Modal.Title>Remark</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <input
                value={Remark || ""}
                placeholder={"Enter Remark"}
                disabled={false}
                // minLength={2}
                maxLength={50}
                onChange={(e) => setRemark(e.target.value)}
                className={`form-control`}
              />
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                {"Submit"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ServicesGetPassList;
